import type {
  ExtractionFailureCode,
  IngestStatus,
} from "@contract-manager/shared";
import type { MessageKey } from "./i18n/messages";

export type StatusTone = "pending" | "working" | "done" | "failed";

export interface StatusPresentation {
  readonly labelKey: MessageKey;
  readonly tone: StatusTone;
}

const INGEST_TONE: Record<IngestStatus, StatusTone> = {
  UPLOADED: "pending",
  EXTRACTING: "working",
  EXTRACTED: "done",
  APPROVED: "done",
  FAILED: "failed",
};

export function presentIngestStatus(status: IngestStatus): StatusPresentation {
  return { labelKey: `ingest.${status}`, tone: INGEST_TONE[status] };
}

/**
 * Plain-language failure reasons.
 *
 * The codes exist so the cause is not guessed at later
 * (docs/pdf-extraction-design.md §6); showing the raw code to a legal reviewer
 * would waste that, so each message says what to do about it.
 */
export function presentFailureCode(
  code: ExtractionFailureCode | undefined,
): MessageKey | null {
  return code === undefined ? null : `failure.${code}`;
}

/**
 * Whether a run finished but lost pages. `EXTRACTED` with a gap is the case
 * worth surfacing: nothing else in the UI would say so.
 */
export function hasIncompleteCoverage(
  coverage:
    | {
        coverageRate: number;
      }
    | undefined,
): boolean {
  return coverage !== undefined && coverage.coverageRate < 1;
}
